import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
// import { fontFamily, fontFamilySans } from '@clockwise/web-commons/src/styles/type.styles';

const container: CSSProperties = {};

const billingAddressTextFieldContainer: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  margin: "10px 0",
};

const billingAddressInput: CSSProperties = {
  padding: "12px 14px",
  color: greys.slate,

  // hide the number arrows
  "&::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "&::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
};

const billingAddressInputRoot: CSSProperties = {
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: 5,
    border: `2px solid ${greys.paleGrey} !important`,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: greys.paleGrey,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: greys.paleGrey,
  },
};

export const styles = {
  container,
  billingAddressTextFieldContainer,
  billingAddressInput,
  billingAddressInputRoot,
};
